// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__10Klm","content":"Consent_content__7pxID","footer":"Consent_footer__1FzS2"};